"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryBoxSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _CategoryBox = require("../CategoryBox");
var _utils = require("../CategoryBox/utils");
var _styles = require("../styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `CategoryBox`.
 */
const CategoryBoxSkeleton = ({
  animation = 'pulse',
  className,
  showDescription,
  size = _CategoryBox.CategoryBoxSize.SMALL
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const width = (0, _utils.getCategoryBoxWidth)({
    size
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: className,
    "data-testid": getTestId(_constants.CATEGORY_BOX_SKELETON),
    width: width,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ImageSkeleton, {
      variant: "rectangular",
      size: size,
      animation: animation
    }), showDescription ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
      variant: "rectangular",
      width: "65px",
      height: "21px",
      animation: animation
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
      variant: "rectangular",
      width: "80px",
      height: "30px",
      animation: animation
    })]
  });
};
exports.CategoryBoxSkeleton = CategoryBoxSkeleton;
//# sourceMappingURL=CategoryBoxSkeleton.js.map